import React from "react";
import "./styles.css";
//import { AiOutlineSearch } from "react-icons/ai";
//import { IoIosArrowDown } from "react-icons/io";
//import { Collapse } from "react-collapse";
import FormRISolicitarConsulta from './../../../components/Forms_RepresentanteDeInstituição/Tela_RI_Solicitar_Consulta';
//import {NavLink} from "react-router-dom";
import SideNav from './../../../components/SideNav_RI';

//import api from "./../../../services/api";
//import { user_token } from '../../../services/Auth';
import Grid from '@material-ui/core/Grid';

//var _id = localStorage.getItem("id_agent");
//var token = localStorage.getItem(user_token);

export default class SolicitarConsulta extends React.Component {

    state = {
        paciente: [],
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = async () => {
        const { id } = this.props.match.params;
        console.log(id);
    
      };

    render() {
        return (
        <>
        <SideNav />
        <div id="top-RI-Cadastro">
        <Grid container spacing={0} direction="row" justify="left"  alignItems="center" style={{ marginTop: '-35vh'}}>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center"></Grid>
            <Grid item xs={8} sm={8} md={10} lg={10}></Grid>   
            <Grid item xs={2} sm={2} md={1} lg={1} align="center"></Grid>
        </Grid>
        </div>
          <Grid container spacing={0} direction="row" justify="left"  alignItems="center">
          <Grid item xs={12} sm={12} md={10} lg={3} align="center"></Grid>
          <Grid item xs={12} sm={12} md={10} lg={6} align="left">
          <div id="main-RI-Consulta-Pendente">
          <h1 id="title">Solicitar Consulta</h1>
          <br></br>
          <FormRISolicitarConsulta user_id={this.props.match.params}/>
        </div>
        </Grid>
        </Grid>
      </>
        );
    }
}

